"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcornItemViewScreen = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var AcornScreenHeader_1 = require("./AcornScreenHeader");
var SuspenseFactoryContext_1 = require("./suspense/SuspenseFactoryContext");
var AcornItemViewScreen = function (props) {
    var _a, _b;
    var match = react_router_dom_1.useRouteMatch();
    var suspenseContext = SuspenseFactoryContext_1.useSuspenseFactoryContext();
    var PrimaryContentSuspenseComponent = suspenseContext.getSuspenseComponent(SuspenseFactoryContext_1.CommonSuspenseType.PrimaryContent);
    return (react_1.default.createElement("div", { className: "l-view" },
        react_1.default.createElement("header", { className: "l-view__header" },
            react_1.default.createElement(AcornScreenHeader_1.AcornScreenHeader, __assign({ callToActionContent: react_1.default.createElement(react_router_dom_1.Link, { to: (_a = props.editUrl) !== null && _a !== void 0 ? _a : match.url + '/edit', className: "c-button +ghost" }, "Edit") }, props))),
        react_1.default.createElement("div", { className: "l-view__body" },
            react_1.default.createElement(PrimaryContentSuspenseComponent, { itemFetchingStatus: props.itemFetchingState }, props.children)),
        props.asideContent && (react_1.default.createElement("aside", { className: "l-view__aside" },
            props.asideTitle && react_1.default.createElement("h2", { className: "c-heading +h2" }, (_b = props.asideTitle) !== null && _b !== void 0 ? _b : ''),
            react_1.default.createElement(PrimaryContentSuspenseComponent, { itemFetchingStatus: props.itemFetchingState }, props.asideContent)))));
};
exports.AcornItemViewScreen = AcornItemViewScreen;
//# sourceMappingURL=AcornItemViewScreen.js.map